import script from "./CardProduct.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardProduct.component.vue?vue&type=script&lang=ts&setup=true"

import "./CardProduct.component.vue?vue&type=style&index=0&id=7d2616bf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2616bf"]])

export default __exports__